import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/context/LanguageContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Documents from "@/pages/Documents";
import Telecom from "@/pages/Telecom";
import Finance from "@/pages/Finance";
import Contact from "@/pages/Contact";
import MaintenancePage from "@/pages/MaintenancePage";
import { shouldShowFullSite } from "@/lib/maintenance";

const ToasterEl = () => (
  <Toaster
    theme="dark"
    position="bottom-right"
    toastOptions={{
      style: {
        background: "#17223a",
        border: "1px solid rgba(255,255,255,0.08)",
        color: "#fff",
        borderRadius: "2px",
      },
    }}
  />
);

function App() {
  const fullSite = shouldShowFullSite();

  return (
    <div className="App min-h-screen bg-[#0f1826] text-white">
      <LanguageProvider>
        <BrowserRouter>
          {fullSite ? (
            <>
              <ScrollToTop />
              <Nav />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/telecom" element={<Telecom />} />
                  <Route path="/finance" element={<Finance />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="*" element={<Home />} />
                </Routes>
              </main>
              <Footer />
            </>
          ) : (
            <Routes>
              <Route path="*" element={<MaintenancePage />} />
            </Routes>
          )}
          <ToasterEl />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
